import { render } from "./ManageInvoice.vue?vue&type=template&id=36a7c52d"
import script from "./ManageInvoice.vue?vue&type=script&lang=js"
export * from "./ManageInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/ManageInvoice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36a7c52d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36a7c52d', __exports__)) {
    api.reload('36a7c52d', __exports__)
  }
  
  module.hot.accept("./ManageInvoice.vue?vue&type=template&id=36a7c52d", () => {
    api.rerender('36a7c52d', render)
  })

}


export default __exports__